import { PlayWindow } from "../api";
import { CreateElement, Rect, Scale, Size } from "../MyHelpers";
import { ZIndex } from "../ZIndex";

export interface MarkersInfoColors {
	MarkerbackgroundColor: string;
}

export class WinInfoMarker {
	public element: HTMLElement;
	public containerElement: HTMLElement;

	public lineIndex: number;
	public backgroundElement: HTMLElement;

	public constructor() {
		this.containerElement = CreateElement("div", {
			classes: ["line-marker-container"], style: {
				//flexGrow: "1",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				//height : "100%",
				margin: "auto",
				//padding : Scale.fhpx(5),

			}
		});






		this.element = CreateElement("div", {
			classes: ["line-marker-number"], innerHTML: "00", style: {
				borderRadius: Scale.XYpx(25),
				width: "100%",
				height: "100%",
				textAlign: "center",
				fontFamily: "NotoSansDisplay-Bold", // default font
				fontSize: Scale.fhpx(35),
				color: "white",
				textShadow: "2px 2px 2px black, 2px -2px 2px black, -2px -2px 2px black",
				margin: "auto",
				display: "block",


			}
		});
		this.element.style.zIndex = ZIndex.WinLines.toString();

		this.containerElement.appendChild(this.element);
	}

	public Show(lineIndex: number): void {
		this.element.innerHTML = "" + (lineIndex + 1);
		this.element.style.visibility = "visible";
	}

	// public Hide(): void {
	// 	this.element.style.visibility = "hidden";
	// }
}

export class WinLineInfo1Marker {
	private leftMarkers: WinInfoMarker[] = [];
	private leftVisibleMarker: WinInfoMarker = null;

	private rightMarkers: WinInfoMarker[] = [];
	private rightVisibleMarker: WinInfoMarker = null;

	private leftContainer: HTMLElement = null;
	private rightContainer: HTMLElement = null;

	private leftGroup: HTMLElement[] = [];
	private rightGroup: HTMLElement[] = [];


	//private view: HTMLElement = null;
	private lines: number[][] = [];

	protected leftWidth: number = Scale.W(60);
	protected leftOffset: number = Scale.X(8);

	protected rightWidth: number = Scale.W(60);
	protected rightOffset: number = Scale.X(8);
	protected symbolHeight: number;
	protected slotWindow: Rect;
	protected totalPlayLines : number = 0
	constructor(slotWindow: Rect, slotWindowSymbolSize: PlayWindow, lines: number[][]) {
		this.symbolHeight = slotWindow.height / slotWindowSymbolSize.Height;
		this.lines = lines;		
		this.totalPlayLines = this.lines.length - 1;
		this.slotWindow = slotWindow;
	}

	public CreateGroups(color: MarkersInfoColors) {

		let cssBacgkround: Partial<CSSStyleDeclaration> = {
			borderRadius: Scale.XYpx(30),
			border: `${Scale.XYpx(5)} solid transparent`,
			//backgroundClip: "padding-box",
			borderStyle: "inset",
			justifyContent: "space-evenly",
			backgroundOrigin: "border-box",
			backgroundClip: "content-box, border-box",
			backgroundImage: color.MarkerbackgroundColor,
		};

		this.leftContainer = CreateElement("div", {
			classes: ["line-markers-left"], style: {
				position: "absolute",
				top: this.slotWindow.y + "px",
				height: this.slotWindow.height + "px",
				left: (this.slotWindow.x - this.leftWidth - this.leftOffset) + "px",
				width: this.leftWidth + "px",
				display: "flex",
				flexDirection: "column-reverse",
				alignItems: "center",
				...cssBacgkround,
				justifyContent: "center",
			}
		});

		this.leftContainer.style.zIndex = ZIndex.WinLines.toString();

		this.rightContainer = CreateElement("div", {
			classes: ["line-markers-right"], style: {
				position: "absolute",
				top: this.slotWindow.y + "px",
				height: this.slotWindow.height + "px",
				right: (this.slotWindow.x  - this.rightWidth - this.rightOffset) + "px",
				width: this.rightWidth + "px",
				display: "flex",
				flexDirection: "column-reverse",
				alignItems: "center",
				...cssBacgkround,
				justifyContent: "center",
			}
		});

		this.rightContainer.style.zIndex = ZIndex.WinLines.toString();


		//create Text Group
		let textGroup : HTMLElement [] = [] ;
		for (let index = 0; index < 2; index++) {
			//text Group 
			let containerTextElement = CreateElement("div", {
				classes: ["line-textmarker-container"], style: {
					//flexGrow: "1",					
					width : "60%",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					//height : "100%",
					margin: "auto",
					//padding : Scale.fhpx(5),
					writingMode : "vertical-lr",
					textOrientation : "upright",
					position : "relative",
					top : Scale.Ypx(15),
				}
			});

			let element = CreateElement("div", {
				parentToAppend: containerTextElement,
				classes: ["line-textmarker"], innerHTML: "00", style: {
					//borderRadius: Scale.XYpx(25),
					//width: "100%",
					//height: "100%",
					textAlign: "center",
					fontFamily: "NotoSansDisplay-Bold", // default font
					fontSize: Scale.fhpx(30),
					color: "white",
					textShadow: "2px 2px 2px black, 2px -2px 2px black, -2px -2px 2px black",
					margin: "auto",
					display: "block",					
				}
			});

			element.innerText = "LINES";

			textGroup.push(containerTextElement);

		}

		


		//Create 1 Group per side 
		let leftGroup = CreateElement("div", {
			classes: ["line-markers-groupLeft"], style: {
				position: "relative",
				height: this.slotWindow.height / 6 + "px",
				width: this.rightWidth + "px",
				display: "flex",
				alignContent: "center",
				flexDirection: "column",
				justifyContent: "center",
				borderTop: Scale.fhpx(1) + "inset black",

			}
		});
		

		this.leftContainer.appendChild(leftGroup);
		

		let rightGroup = CreateElement("div", {
			classes: ["line-markers-groupRight"], style: {
				position: "relative",
				height: this.slotWindow.height / 6 + "px",
				width: this.rightWidth + "px",
				display: "flex",
				alignContent: "center",
				flexDirection: "column",
				justifyContent: "center",
				borderTop: Scale.fhpx(1) + "inset black",
			}
		});
		
		this.rightContainer.appendChild(rightGroup);


		//console.log("NewIndex:", newIndex);
		// create markers
		let leftMarker: WinInfoMarker = new WinInfoMarker();
		let rightMarker: WinInfoMarker = new WinInfoMarker();

		//Append Left Group
		leftGroup.appendChild(leftMarker.containerElement);
		leftGroup.appendChild(textGroup[0]);	
		leftMarker.element.style.fontSize = Scale.fhpx(24);
		leftMarker.Show(this.totalPlayLines);

		//Append Right Group			
		rightGroup.appendChild(rightMarker.containerElement);
		rightGroup.appendChild(textGroup[1]);		
		rightMarker.element.style.fontSize = Scale.fhpx(24);
		rightMarker.Show(this.totalPlayLines);

		// hide markers by default		
		this.leftMarkers.push(leftMarker);
		this.rightMarkers.push(rightMarker);
	}

	public Show(lineIndex: number): void {


		// let rowLeft = this.lines[lineIndex][0];


		// this.leftVisibleMarker = this.leftMarkers[lineIndex];
		// this.leftVisibleMarker.backgroundElement.style.transform = "scale(1.25)";
		// // this.leftVisibleMarker.Show(lineIndex);

		// let rowRight = this.lines[lineIndex][this.lines[lineIndex].length - 1];

		// this.rightVisibleMarker = this.rightMarkers[lineIndex];
		// this.rightVisibleMarker.backgroundElement.style.transform = "scale(1.25)";
		// // this.rightVisibleMarker.Show(lineIndex);
	}



	public Hide(): void {
		// if (this.leftVisibleMarker != null) {
		// 	this.leftVisibleMarker.backgroundElement.style.transform = "scale(1)";
		// 	this.leftVisibleMarker = null;
		// }

		// if (this.rightVisibleMarker != null) {
		// 	this.rightVisibleMarker.backgroundElement.style.transform = "scale(1)";
		// 	this.rightVisibleMarker = null;
		// }
	}

	public LeftView(): HTMLElement {
		return this.leftContainer;
	}

	public RightView(): HTMLElement {
		return this.rightContainer;
	}


	protected color: MarkersInfoColors;
	public SaveColor(color: MarkersInfoColors) {
		this.color = color;
	}
}